import { useState } from "react";
import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import { AdminListCard } from "./AdminListCard";

export default {
  title: "CatalogIndex/AdminListCard",
  component: AdminListCard,
};

export const Minimal = () => (
  <AdminListCard
    title="Project Governance"
    onNew={() => {}}
    newButtonLabel="Add Governance"
  >
    <div style={{ padding: 16 }}>(table goes here)</div>
  </AdminListCard>
);

export const WithBatchPill = () => (
  <AdminListCard
    title="Project Governance"
    onNew={() => {}}
    newButtonLabel="Add Governance"
    selectedCount={3}
    batchActions={[{ icon: faTrashCan, label: "Archive", onClick: () => {} }]}
  >
    <div style={{ padding: 16 }}>(table with 3 rows checked)</div>
  </AdminListCard>
);

export const WithSearch = () => {
  const [value, setValue] = useState("");
  return (
    <AdminListCard
      title="Clients"
      onNew={() => {}}
      newButtonLabel="Add A Client"
      searchProps={{
        placeholder: "Search by client name",
        value,
        onChange: (e) => setValue(e.target.value),
        onSubmit: (e) => e.preventDefault(),
        onClear: () => setValue(""),
        label: "Search Clients",
      }}
    >
      <div style={{ padding: 16 }}>(table goes here)</div>
    </AdminListCard>
  );
};
